uniform float uHeat;
uniform float uHeatFallof;
uniform float uHardened;

// vec4 middleColor = vec4(240. / 255., 69. / 255., 47. / 255., 1.);  // green
vec4 firstColor = vec4(0.2, 0, 0, 1); //red
vec4 middleColor = vec4(1, 0.12, 0.04, 1); // blue
vec4 endColor = vec4(1, 1, 0.52, 1); // blue
vec4 hardenedColor = vec4(0.5, 0.5, 0.5, 1.0);
